import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MainNav } from 'app/agriculture/FarmMain/TopBar/components/MainNav/MainNav';
import { HouseIcon } from 'app/agriculture/icons';
import { Button } from 'app/agriculture/components/Button/Button';
import { ComponentProps, useEffect, useMemo, useState } from 'react';

// This should all be replaced when we rip the 'mapmode' stuff out of MainNav
function generateBackOfficeNavConfig(farmId?: string) {
    if (farmId == null) return null;

    return [
        { pathname: '/', text: 'Home', startIcon: <HouseIcon /> },
        { pathname: `/farms/${farmId}/edit`, text: 'Farm Settings', startIcon: 'settings' },
        { pathname: `/farms/${farmId}/users`, text: 'Manage Users', startIcon: 'profile' },
    ] as const satisfies {
        pathname: string;
        text: string;
        startIcon: ComponentProps<typeof Button>['startIcon'];
    }[];
}

export function BackOfficeNav() {
    const { farmId } = useParams();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const backOfficeConfig = useMemo(() => generateBackOfficeNavConfig(farmId), [farmId]);

    // TODO: This should all be replaced when we rip the 'mapmode' stuff out of MainNav
    const [activeTab, setActiveTab] = useState(
        backOfficeConfig?.find((item) => pathname === item.pathname)?.text ?? '',
    );

    useEffect(() => {
        setActiveTab(backOfficeConfig?.find((item) => pathname === item.pathname)?.text ?? '');
    }, [pathname, backOfficeConfig]);

    if (farmId == null || backOfficeConfig == null) return null;

    return (
        <>
            <MainNav
                // This should all be replaced when we rip the 'mapmode' stuff out of MainNav
                items={backOfficeConfig.map(({ text, startIcon, pathname }) => ({
                    text,
                    startIcon,
                    onClick: () => {
                        setActiveTab(text);
                        navigate(pathname);
                    },
                }))}
                activeTab={activeTab}
            />
            <Button
                text="Launch Faarm"
                endIcon="goto"
                onClick={() => {
                    navigate(`/${farmId}`);
                }}
            />
        </>
    );
}
